<template>
  <!-- 横向堆叠柱状图 -->
  <div :ref="refId" :datas=datas style="width: 100%;height: 100%;"></div>
</template>
  
  <script>
// refId                  图表id
// datas                  图表数据源
// colorList              颜色值
// yAxisList              纵轴值
// legendList             legend值
// nameColor              文字颜色

export default {
  props: ['refId', 'datas', 'colorList', 'yAxisList', 'legendList', 'nameColor'],
  data() {
    return {
      pieEcharts: '',
      pieOption: {},
    };
  },
  watch: {
    datas: {
      handler(newValue) {
        this.setPieOption(this.refId, newValue, this.colorList, this.yAxisList, this.legendList, this.nameColor);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas.length > 0) {
      this.$nextTick(() => {
        this.setPieOption(this.refId, this.datas, this.colorList, this.yAxisList, this.legendList, this.nameColor);
      })
    }
  },
  methods: {
    isArray(data) {  //判断是单根柱状图还是多根柱状图
      let str1 = 1
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (Array.isArray(data[i])) {
            return str1 = 2
          } else {
            return str1 = 1
          }
        }
      }
      return str1
    },
    setPieOption(refId, datas, colorList, yAxisList, legendList, nameColor) {
      let dataList = JSON.parse(JSON.stringify(datas))     //原数据
      var arrList = []
      var obj = {}
      if (this.isArray(dataList) == 1) {
        obj = {
          name: '',
          type: 'bar',
          // barWidth: '40%',
          itemStyle: {
            normal: {
              color: function () {
                var myColor = ['#32f3a0', '#dcee37', '#fad951', '#fa903e', '#27727B', '#788e78', '#3962a8', '#aa8227', '#922593', '#60C0DD'];
                return colorList ? colorList[0] : myColor[0]
              },
              barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）

              // barBorderRadius: [2, 2, 2, 2], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
            }
          },
          label: {
            show: true, // 开启显示
            // align: 'left',
            position: 'insideRight',
            distance: 15,
            textStyle: { // 数值样式
              color: 'black',
              fontSize: 25,
            },
          },
          data: dataList,
        }
        arrList.push(obj)
      } else {
        for (let i = 0; i < dataList.length; i++) {
          obj = {
            name: legendList[i],
            type: 'bar',
            stack: 'truck',
            // verticalAlign: 'middle',
            label: {
              normal: {
                show: true,
                position: 'inside',
                color: nameColor ? nameColor : "black",
                textStyle: {
                  fontSize: 25,
                }
              }
            },
            itemStyle: {
              normal: {
                color: function () {
                  var myColor = ['#32f3a0', '#dcee37', '#fad951', '#fa903e', '#27727B', '#788e78', '#3962a8', '#aa8227', '#922593', '#60C0DD'];
                  return colorList ? colorList[i] : myColor[i]
                },
                barBorderRadius: [8, 8, 8, 8], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              }
            },
            data: dataList[i],
          }
          arrList.push(obj)
        }
      }


      this.pieEcharts = this.$echarts.init(this.$refs[refId]);
      this.pieOption = {
        tooltip: {
          trigger: 'axis',
          confine: true, // 浮窗限制在图表内
          extraCssText: 'z-index:1',
          axisPointer: {
            type: 'shadow',
            label: {
              backgroundColor: '#6a7985',
            },
          },
        },
        grid: {
          top: '2%',
          left: '3%',
          right: '4%',
          bottom: legendList.length > 0 ? '8%' : '0%',
          containLabel: true
        },
        legend: {
          bottom: 0,
          // icon: 'circle',
          // orient: 'vertical',
          textStyle: {
            // fontSize: 10,//字体大小
            color: nameColor ? nameColor : 'black',//字体颜色
            fontSize: 25
          },
          data: legendList,
        },
        color: colorList,
        xAxis: {
          type: 'value',
          axisLine: { // 轴线
            show: false,
          },
          axisTick: { show: false }, // 刻度
          splitLine: { show: false }, //中间线
          axisLabel: { // y轴坐标轴样式
            show: false,
            interval: 0,
            textStyle: {
              color: nameColor ? nameColor : '#bcc2cf',
              fontSize: 25,
            },
          },
        },
        yAxis: {
          type: 'category', // 将xAxis的type设置为value, 将yAxis的type设置为category即可实现横向显示
          nameTextStyle: {
            align: 'left',
            color: '#1d244e',
            fontSize: 25
          },
          axisLine: { show: false }, // 轴线
          axisTick: { show: false }, // 刻度
          splitLine: {
            show: false,
            lineStyle: {
              color: 'rgba(158, 158, 158,0.3)',
            },
          },
          axisLabel: { // y轴坐标轴样式
            show: true,
            lineHeight: 25,
            interval: 0,
            textStyle: {
              color: nameColor ? nameColor : 'black',
              fontSize: 25,
            },
          },
          data: yAxisList,
        },
        series: arrList
      };
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);
      window.addEventListener('resize', () => {
        this.pieEcharts.resize();
      });
    },
  },
};
  </script>
  
  <style scoped>
</style>
  